var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-arrow-45deg';
                    var viewUrl = 'gfx/sprite.svg#view-icon-arrow-45deg';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 26 27',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };